/**
 * Ids the control must reference with `aria-describedby`. Kept out of `Field.tsx` so that file
 * exports only components (React Fast Refresh needs that).
 */
export function fieldDescriptionIds(id: string, hint?: string, error?: string): string | undefined {
  const ids = [hint ? `${id}-hint` : null, error ? `${id}-error` : null].filter(Boolean);
  return ids.length > 0 ? ids.join(' ') : undefined;
}
